import script from "./rec-text-field.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-text-field.vue?vue&type=script&lang=ts&setup=true"

import "./rec-text-field.vue?vue&type=style&index=0&id=c82c4624&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c82c4624"]])

export default __exports__